import type { ExceptionsPayload } from './types';

/**
 * Exec exception cards + KPI bands. The Go side computes chain-wide once per
 * TTL and strips per-permission, so a 200 may carry only a subset of cards.
 * 403 (no view:overview) and network errors both resolve to null — the
 * Overview simply omits the section.
 */
export async function fetchExceptions(): Promise<ExceptionsPayload | null> {
  try {
    const res = await fetch('/api/exceptions', { credentials: 'same-origin' });
    if (!res.ok) return null;
    return (await res.json()) as ExceptionsPayload;
  } catch {
    return null;
  }
}
